
export const ExchangeRateRefDateMappingConstant = {
    Table: {
        CUSTOMER_CODE: "Customer Code",
        DOC_TYPE: "Doc Type",
        ADJ_TYPE: "Adj Type",
        EXCHANGE_RATE_REF_DATE_ATTR: "Reference Date",
        ADJUSTMENT: "Adjustment",
        ACTIVE_IND: "Active Ind.",
    },
    TITLE: "Exchange Rate Reference Date Mapping",
    CATEGORY: "Invoice",
}
export const exchangeRateRefDateRequiredFieldList: string[] = [
    'customerCode',
    'docType',
    'adjType',
    'exchangeRateRefDateAttr',
    'adjustment',
    'activeInd',
];